import React from "react";
import { useLocation } from "react-router-dom";
import AIAreaHome from "./AIAreaHome";
import UploadDocuments from "./UploadDocuments";
import KnowledgeDocumentView from "./KnowledgeDocumentView";
import KnowledgeDocumentForm from "./KnowledgeDocumentForm";

const Index = () => {
  const { pathname } = useLocation();

  const viewMatch = pathname.match(/\/ai-area\/upload-documents\/view\/([^/]+)/);
  if (viewMatch) {
    return (
      <KnowledgeDocumentView id={decodeURIComponent(viewMatch[1])} />
    );
  }

  const editMatch = pathname.match(/\/ai-area\/upload-documents\/edit\/([^/]+)/);
  if (editMatch) {
    return (
      <KnowledgeDocumentForm
        mode="edit"
        id={decodeURIComponent(editMatch[1])}
      />
    );
  }

  if (pathname.includes("/ai-area/upload-documents/add")) {
    return <KnowledgeDocumentForm mode="add" />;
  }

  if (pathname.includes("/ai-area/upload-documents")) {
    return <UploadDocuments />;
  }

  return <AIAreaHome />;
};

export default Index;
